import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "./pwa/registerSW";
import { setupErrorReporter } from "./utils/errorReporter";
import { initSentry } from "./utils/sentryInit";

initSentry();
setupErrorReporter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
